import { render, staticRenderFns } from "./QueryPage.vue?vue&type=template&id=64c71a4b&scoped=true"
import script from "./QueryPage.vue?vue&type=script&lang=js"
export * from "./QueryPage.vue?vue&type=script&lang=js"
import style0 from "./QueryPage.vue?vue&type=style&index=0&id=64c71a4b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c71a4b",
  null
  
)

export default component.exports